// extracted by mini-css-extract-plugin
module.exports = {"modal":"AlertModal_modal__-8lMs","inner":"AlertModal_inner__jdMYp","description":"AlertModal_description__W6pA1","buttonsWrapper":"AlertModal_buttonsWrapper__1PEKs"};